import { AuthState } from "@/store/auth/reducer";
import { RootState } from "@/store/store";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { DefaultRootState, useSelector } from "react-redux";
import { RoleTestFn } from "../auth/roleTests";

const withAuthentication = (roleTest: RoleTestFn) => {
  return <P extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<P>
  ): React.FC<P> => {
    const RequiresAuthentication: React.FC<P> = (props) => {
      // get user role from redux state
      const role = useSelector<RootState>(({ auth }) => auth.role) as string;
      const router = useRouter();

      useEffect(() => {
        if (role != null && (role === "guest" || !roleTest(role)))
          router.push("/login");
      }, [role, router]);

      // if there's a loggedInUser, show the wrapped page, otherwise show a loading indicator
      return role && role !== "guest" ? (
        <WrappedComponent {...(props as P)} />
      ) : (
        <div>Loading...</div>
      );
    };

    RequiresAuthentication.displayName = `withAuthentication(${WrappedComponent.displayName})`;

    return RequiresAuthentication;
  };
};

export default withAuthentication;
